<template>
  <div class="counter fontWeightBlack ">
    <p class="counterTitle has-text-white">Casas entregadas</p>
    <ICountUp
      class="has-text-white fontWeightBlack fontMoreBlack mt-0 pt-0"
      :delay="delay"
      :endVal="endVal"
      :options="options"
      @ready="onReady"
    />
  </div>
</template>

<script type="text/babel">
  import ICountUp from 'vue-countup-v2';
  export default {
    name: 'demo',
    components: {
      ICountUp
    },
    data() {
      return {
        delay: 500,
        endVal: 87,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: '',
          duration: 4
        },
        
      };
    },
    methods: {
      onReady: function(instance, CountUp) {
        const that = this;
        instance.update(that.endVal + 19);
        console.log(CountUp)
      }
    }
  };
</script>
